import BiometricService from "@/app/services/Biometric/BiometricService"

/**
 * Resolves to whether this device has an enrolled fingerprint credential.
 * Never rejects. A floating checkFingerprint(...).then(...) was escaping as an
 * onunhandledrejection whenever the auth service exceeded the axios timeout
 * (Sentry FRONT-MAIN 713/721/746). "Unknown" is not an error here -- it just
 * means the fingerprint shortcut is not offered on this render.
 */
export const probeFingerprintAvailability = async (
  deviceID: string | null,
): Promise<boolean> => {
  if (!deviceID) return false
  try {
    const response = await BiometricService.checkFingerprint(deviceID)
    return !!response.data?.message
  } catch {
    return false
  }
}
